<template>
  <div>
    <div style="height: 80px">
      <el-upload
        ref="upload"
        :action="actionUrl"
        :multiple="false"
        :limit="1"
        :headers="header"
        :data="data"
        :on-success="importSuccess"
        accept=".xlsx"
        list-type="file"
      >
        <el-button type="primary" icon="el-icon-upload">点击上传</el-button>
      </el-upload>
    </div>
    <el-link icon="el-icon-download" type="danger" style="float: right" @click="downloadTemplate">下载导入模板</el-link>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      title="提示信息"
      width="30%"
      @close="dialogVisible = false"
    >
      <span>{{ dialogMsg }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import { getToken } from '@/utils/examMan/auth'
import { download } from '@/utils/examMan/request'

export default {
  name: 'ImportExcel',
  props: {
    title: String,
    action: String,
    data: Object,
    template: String
  },
  data() {
    return {
      dialogVisible: false,
      dialogMsg: '',
      // 上传头
      header: {

      },
      actionUrl: ''
    }
  },

  watch: {
    // 检测查询变化
    action: {
      handler() {
        let Token = window.localStorage.Token;
        this.header = {
          Authorization:"Bearer " + Token
        }
        //  process.env.VUE_APP_BASE_API +
        this.actionUrl = this.action
      }
    }
  },

  created() {
    let Token = window.localStorage.Token
    this.header = {
      Authorization:"Bearer " + Token
    }
    // this.header = { token: getToken() }
    //  process.env.VUE_APP_BASE_API +
    this.actionUrl =  this.action
  },

  methods: {

    downloadTemplate() {
      if (this.title == '试题') {
        window.open('https://simpleepass-oss.wlines.cn/erptrain/template/%E8%AF%95%E9%A2%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx')
      } else if (this.title == '成绩') {
        window.open('https://simpleepass-oss.wlines.cn/erptrain/template/%E6%88%90%E7%BB%A9%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20.xlsx')
      } else {
        return download(this.template, {}, `${this.title}导入模板.xlsx`)
      }
    },

    importSuccess(resp) {
      // 清除内容
      this.$refs.upload.clearFiles()
      if (resp.code == 200) {
        this.$message({
          message: '数据导入成功！',
          type: 'success'
        })

        console.log('+++数据导入成功！', resp)
        this.$emit('success', resp)
      } else {
        // 用弹窗提示信息
        // this.dialogMsg = resp.msg
        this.dialogMsg = "请检查导入文件是否正确"
        this.dialogVisible = true
      }
    }

  }
}
</script>
